'use client'

import dynamic from 'next/dynamic'
import { LoggedInSkeleton } from './logged-in-skeleton'

export const LoggedInClient = dynamic(() => import('./logged-in').then(module => module.LoggedIn), {
  ssr: false,
  loading: LoggedInSkeleton,
})
